@if (forms) {
  <div class="keys-container astral-stack-m">
    @for (form of $any(forms.controls); track form; let i = $index) {
      <div class="keys-container__key-box astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
        <h5 class="keys-container__key-title">{{ 'KEYTYPE.KEY_X_OF_Y' | translate : { x: i + 1, y: forms.controls.length } }}</h5>

        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['keyTypeId']" [itemsSource]="keyTypes"></astral-select>
          <astral-input [control]="form.controls['keysToHandOut']" [integerOnly]="true"></astral-input>
          <astral-input [control]="form.controls['quantityInStorage']" [integerOnly]="true"></astral-input>
          <astral-input [control]="form.controls['quantityLentOut']" [integerOnly]="true"></astral-input>
          <astral-input [control]="form.controls['quantity']" [integerOnly]="true"></astral-input>
          <astral-input [control]="form.controls['systemNumber']"></astral-input>
          <astral-input [control]="form.controls['marking']"></astral-input>
          <astral-input [control]="form.controls['caption']"></astral-input>
          <astral-input [control]="form.controls['supplier']"></astral-input>

          <div class="astral-form-adjacent-action">
            <astral-button variant="secondary" size="small" type="button" labelKey="DELETE_BTN" icon="trash" (click)="delete(form)">
            </astral-button>
          </div>
        </astral-layout-group>
      </div>
    }

    <div>
      <astral-button variant="primary" size="small" type="button" labelKey="KEYTYPE.ADD_KEY" icon="plus" (click)="addKey()"></astral-button>
    </div>
  </div>
}
@if (keyTypes.length === 0) {
  <app-information-block [text]="'KEYTYPE.NO_KEYTYPES'"></app-information-block>
}
